module.exports = __webpack_public_path__ + "media/flags/ba-6f76da08.svg";